// extracted by mini-css-extract-plugin
module.exports = {"card":"statcard_card__38fJo","card__data":"statcard_card__data__3x-_M","card__caption":"statcard_card__caption__1JxSB"};